import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/lems-v1/images/calendar-icon.svg'


const _hoisted_1 = { class: "files-pages" }
const _hoisted_2 = { class: "files-pages-filters" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "custom-row" }
const _hoisted_5 = { class: "f-p-f-left" }
const _hoisted_6 = { class: "row-search" }
const _hoisted_7 = { class: "files-page-content" }
const _hoisted_8 = { class: "custom-row" }
const _hoisted_9 = { class: "files-pg-sidebar" }
const _hoisted_10 = { class: "custom-date-box-in" }
const _hoisted_11 = { class: "custom-date-box-date custom-date-box-start" }
const _hoisted_12 = ["max"]
const _hoisted_13 = { class: "custom-date-box-date custom-date-box-end" }
const _hoisted_14 = ["max"]
const _hoisted_15 = { class: "files-content-rigth" }
const _hoisted_16 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_17 = {
  key: 1,
  class: "error-state"
}
const _hoisted_18 = { style: {"color":"red"} }
const _hoisted_19 = {
  key: 2,
  class: "files-list-section"
}
const _hoisted_20 = { class: "files-list-hd" }
const _hoisted_21 = { class: "files-list-btm" }
const _hoisted_22 = {
  key: 0,
  class: "no-files"
}
const _hoisted_23 = { class: "files-d-b" }
const _hoisted_24 = { class: "files-d-b-span" }
const _hoisted_25 = { "data-title": "SHARED BY" }
const _hoisted_26 = { "data-title": "DATE/TIME" }
const _hoisted_27 = { "data-title": "SIZE" }
const _hoisted_28 = { "data-title": "ACTION" }
const _hoisted_29 = { class: "action-dropdown" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "action-dropdownbox-in" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 3,
  class: "v1-pagination-box"
}
const _hoisted_34 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "searchInput",
                placeholder: "Search files...",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearchInput && _ctx.onSearchInput(...args)))
              }, null, 544), [
                [_vModelText, _ctx.searchQuery]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass({ active: _ctx.currentFilter === 'all' }),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFilter('all'))),
                id: "allDocumentsButton"
              }, [
                _createTextVNode(_toDisplayString(_ctx.constants.ALL_DOCUMENTS_BUTTON) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.fileCounts.all), 1)
              ], 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass({ active: _ctx.currentFilter === 'today' }),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setFilter('today'))),
                id: "todayButton"
              }, [
                _createTextVNode(_toDisplayString(_ctx.constants.TODAY_BUTTON) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.fileCounts.today), 1)
              ], 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass({ active: _ctx.currentFilter === 'yesterday' }),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setFilter('yesterday'))),
                id: "yesterdayButton"
              }, [
                _createTextVNode(_toDisplayString(_ctx.constants.YESTERDAY_BUTTON) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.fileCounts.yesterday), 1)
              ], 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass({ active: _ctx.currentFilter === 'lastWeek' }),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setFilter('lastWeek'))),
                id: "lastWeekButton"
              }, [
                _createTextVNode(_toDisplayString(_ctx.constants.LAST_WEEK_AGO_BUTTON) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.fileCounts.lastWeek), 1)
              ], 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass({ active: _ctx.currentFilter === 'lastMonth' }),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setFilter('lastMonth'))),
                id: "lastMonthButton"
              }, [
                _createTextVNode(_toDisplayString(_ctx.constants.LAST_MONTH_AGO_BUTTON) + " ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.fileCounts.lastMonth), 1)
              ], 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass({ active: _ctx.currentFilter === 'custom' }),
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleCustomDate && _ctx.toggleCustomDate(...args))),
                id: "customDateButton"
              }, [
                _createTextVNode(_toDisplayString(_ctx.constants.CUSTOM_DATE_BUTTON) + " ", 1),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "cale-icon" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  })
                ], -1))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([{'custom-date-box-show': _ctx.showCustomDate}, "custom-date-box"])
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", null, "Start Date:", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.startDateString) = $event)),
                      class: "date-input",
                      max: _ctx.maxDate,
                      onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onStartDateChange && _ctx.onStartDateChange(...args))),
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onDateInputClick && _ctx.onDateInputClick(...args)))
                    }, null, 40, _hoisted_12), [
                      [_vModelText, _ctx.startDateString]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", null, "End Date:", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.endDateString) = $event)),
                      class: "date-input",
                      max: _ctx.maxDate,
                      onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onEndDateChange && _ctx.onEndDateChange(...args))),
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onDateInputClick && _ctx.onDateInputClick(...args)))
                    }, null, 40, _hoisted_14), [
                      [_vModelText, _ctx.endDateString]
                    ])
                  ])
                ])
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[20] || (_cache[20] = [
                _createElementVNode("p", null, "Loading files...", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.error), 1),
                _createElementVNode("button", {
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.loadFiles && _ctx.loadFiles(...args))),
                  class: "retry-btn"
                }, "Retry")
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loading && !_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.constants.NAME_TEXT), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.constants.SHARED_BY_TEXT), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.constants.DATE_TIME_TEXT), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.constants.SIZE_TEXT), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.constants.ACTION_TEXT), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  (_ctx.sortedFiles.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[21] || (_cache[21] = [
                        _createElementVNode("p", null, "No files found", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedFiles, (file) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: file.id,
                      class: "files-list-row"
                    }, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("strong", null, _toDisplayString(file.name), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("li", _hoisted_25, _toDisplayString(file.shared_by), 1),
                        _createElementVNode("li", _hoisted_26, _toDisplayString(_ctx.formatDate(file.last_modified)), 1),
                        _createElementVNode("li", _hoisted_27, _toDisplayString(file.formatted_size), 1),
                        _createElementVNode("li", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              class: "action-dots",
                              onClick: ($event: any) => (_ctx.toggleActionDropdown(file.id))
                            }, [...(_cache[22] || (_cache[22] = [
                              _createElementVNode("span", null, null, -1)
                            ]))], 8, _hoisted_30),
                            _createElementVNode("div", {
                              class: _normalizeClass(["action-dropdownbox", { show: _ctx.activeDropdown === file.id }])
                            }, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("a", {
                                  class: "download-icon",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.downloadFile(file))
                                }, _toDisplayString(_ctx.constants.DOWNLOAD_LINK), 9, _hoisted_32)
                              ])
                            ], 2)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.totalPages > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("ul", null, [
                  (_ctx.currentPage !== 1)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: "pagination-first",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                      }, [...(_cache[23] || (_cache[23] = [
                        _createElementVNode("button", { id: "paginationPreButton" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_ctx.totalPages != 1)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: page,
                          onClick: ($event: any) => (_ctx.changePage(page))
                        }, [
                          _createElementVNode("a", {
                            href: "#",
                            class: _normalizeClass({ active: _ctx.currentPage === page })
                          }, _toDisplayString(page), 3)
                        ], 8, _hoisted_34))
                      }), 128))
                    : _createCommentVNode("", true),
                  (_ctx.currentPage !== _ctx.totalPages)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 2,
                        class: "pagination-last",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                      }, [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("button", { id: "paginationNextButton" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}